import type { TagSize } from './types'

/** Размер иконки слева от текста тега, по размеру тега. */
export const TAG_ICON_SIZE: Record<TagSize, number> = {
  S: 12,
  M: 14,
}
